import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAddressFullName } from '../Utils';

export const ClientDetails = (props) => {
  const [open, setOpen] = useState(false);
  const buyerSpec = useRef(null);
  const buyerSpecProperty = useRef(null);
  const navigate = useNavigate();

  const handleBuyerSpecRegistered = () => {
    const options = {
      method: 'GET',
      url: `/buyer/getbuyerrequirements/${buyerSpec.current.dataset.buyerId}`,
    };

    axios
      .request(options)
      .then((response) => {
        // eslint-disable-next-line eqeqeq
        if (response.status === 200 || response.status === 201) {
          let commercialOrResidential =
            response?.data[0]?.commercialOrResidential === false
              ? { Residential: 'false' }
              : { Commercial: 'true' };
          let saleOrLetting =
            response?.data[0]?.saleOrLetting === false
              ? { ForSale: 'false' }
              : { ToLet: 'true' };
          let clientSpec = {
            buyerSpecId: response?.data[0]?.id,
            buyerId: response?.data[0]?.buyerId,
            buyerSpecName: response?.data[0]?.buyerSpecName,
            buyerSpecRef: response?.data[0]?.buyerSpecRef,
            geoRegionId: response?.data[0]?.geoRegionId,
            localityId:
              response?.data[0]?.buyerLocalities[0]?.localityId,
            zoneId: response?.data[0]?.buyerLocalities[0]?.zoneId,
            budgetMin:
              response?.data[0]?.buyerPropertyTypes[0]?.priceFrom,
            budgetMax:
              response?.data[0]?.buyerPropertyTypes[0]?.priceTo,
            propertyTypeGroupId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertyTypeGroupId,
            propertyTypeId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertyTypeId,
            propertySubTypeId:
              response?.data[0]?.buyerPropertyTypes[0]
                ?.propertySubTypeId,
            ...commercialOrResidential,
            ...saleOrLetting,
          };

          navigate('/PropertySearch', {
            state: {
              clientSpec: {
                ...clientSpec,
              },
            },
          });
        }
      })
      .catch(() => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleMobileRegistered = (mobile) => {
    let mobileNumber = parseInt(mobile, 10);
    return `https://wa.me/${mobileNumber}`;
  };

  const handleMobileUnregistered = (mobile) => {
    let mobileNumber = parseInt(mobile, 10);
    return `https://wa.me/356${mobileNumber}`;
  };

  const handleBuyerSpecUnregistered = () => {
    const options = {
      method: 'GET',
      url: `/buyerspec/getviewmodel/${buyerSpec.current.dataset.buyerSpecId}`,
    };

    axios
      .request(options)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          let commercialOrResidential =
            response?.data?.buyerSpec?.commercialOrResidential ===
            false
              ? { Residential: 'false' }
              : { Commercial: 'true' };
          let saleOrLetting =
            response?.data?.buyerSpec?.saleOrLetting === false
              ? { ForSale: 'false' }
              : { ToLet: 'true' };
          let clientSpec = {
            buyerSpecName: response?.data?.buyerSpec?.buyerSpecName,
            buyerSpecRef: response?.data?.buyerSpec?.buyerSpecRef,
            geoRegionId: response?.data?.buyerSpec?.geoRegionId,
            localityId:
              response?.data?.buyerSpec?.buyerLocalities[0]
                ?.localityId,
            zoneId:
              response?.data?.buyerSpec?.buyerLocalities[0]?.zoneId,
            budgetMin:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.priceFrom,
            budgetMax:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.priceTo,
            propertyTypeGroupId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertyTypeGroupId,
            propertyTypeId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertyTypeId,
            propertySubTypeId:
              response?.data?.buyerSpec?.buyerPropertyTypes[0]
                ?.propertySubTypeId,
            ...commercialOrResidential,
            ...saleOrLetting,
          };

          navigate('/PropertySearch', {
            state: {
              clientSpec: {
                ...clientSpec,
              },
            },
          });
        }
      })
      .catch(() => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleBuyerProperties = () => {
    // Navigate immediately and let BuyerProperties handle paged loading
    navigate('/BuyerProperties', {
      state: {
        buyerName: buyerSpecProperty.current.dataset.buyerName,
        buyerRef: buyerSpecProperty.current.dataset.buyerRef,
        buyerSpecId: buyerSpecProperty.current.dataset.buyerSpecId,
        buyerEmail: buyerSpecProperty.current.dataset.buyerEmail,
      },
    });
  };

  return (
    <div className="client-detail-card">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="client-detail-header"
        aria-expanded={open}
      >
        <div className="client-detail-name">
          {props?.contact?.contact?.address?.addressIndividualFirstName}{' '}
          <span>
            {props?.contact?.contact?.address?.addressIndividualSurname}
            {props?.contact?.contact?.address?.addressOrganisationName}
            {props?.contact?.contact?.buyerSpec?.buyerSpecName}
          </span>
        </div>
        <div className="client-detail-meta">
          <span className="client-detail-ref">
            Buyer Ref: {props?.contact?.contact?.buyerRef}
          </span>
          <i
            className={`fas ${open ? 'fa-chevron-up' : 'fa-chevron-down'} client-detail-chevron`}
            aria-hidden="true"
          ></i>
        </div>
      </button>
      {open ? (
        <div className="client-detail-actions">
          {props?.contact?.contact?.address?.addressPhones[0]
            ?.telephoneNo && (
            <a
              className="nav-icon-button client-detail-action"
              href={`tel:${props?.contact?.contact?.address?.addressPhones[0]?.prefix}${props?.contact?.contact?.address?.addressPhones[0]?.telephoneNo}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Call"
            >
              <i className="fa fa-phone" aria-hidden="true"></i>
            </a>
          )}
          {props?.contact?.contact?.buyerSpec?.phoneNo && (
            <a
              className="nav-icon-button client-detail-action"
              href={`tel:+356${props?.contact?.contact?.buyerSpec?.phoneNo}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Call"
            >
              <i className="fa fa-phone" aria-hidden="true"></i>
            </a>
          )}
          {props?.contact?.contact?.address !== null &&
           props?.contact?.contact?.address?.addressEmails[0]?.emailAddress !== undefined ? (
            <a
              className="nav-icon-button client-detail-action"
              href={`mailto: ${props?.contact?.contact?.address?.addressEmails[0]?.emailAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Email"
            >
              <i className="far fa-paper-plane" aria-hidden="true"></i>
            </a>
          ) : null}
          {props?.contact?.contact?.buyerSpec !== null &&
          props?.contact?.contact?.buyerSpec?.email !== null ? (
            <a
              className="nav-icon-button client-detail-action"
              href={`mailto: ${props?.contact?.contact?.buyerSpec?.email}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Email"
            >
              <i className="far fa-paper-plane" aria-hidden="true"></i>
            </a>
          ) : null}
          {props?.contact?.contact?.address?.addressPhones[0]
            ?.telephoneNo && (
            <a
              className="nav-icon-button client-detail-action"
              href={handleMobileRegistered(
                `${props?.contact?.contact?.address?.addressPhones[0]?.prefix}${props?.contact?.contact?.address?.addressPhones[0]?.telephoneNo}`,
              )}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
            </a>
          )}
          {props?.contact?.contact?.buyerSpec?.phoneNo && (
            <a
              className="nav-icon-button client-detail-action"
              href={handleMobileUnregistered(
                `${props?.contact?.contact?.buyerSpec?.phoneNo}`,
              )}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
            </a>
          )}
          {props?.contact?.contact?.address !== null &&
            props?.contact?.contact?.buyerId && (
              <button
                type="button"
                className="nav-icon-button client-detail-action"
                onClick={handleBuyerSpecRegistered}
                ref={buyerSpec}
                data-buyer-id={props?.contact?.contact?.buyerId}
                aria-label="Buyer spec"
              >
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            )}
          {props?.contact?.contact?.buyerSpec !== null &&
            props?.contact?.contact?.buyerSpecId && (
              <button
                type="button"
                className="nav-icon-button client-detail-action"
                onClick={handleBuyerSpecUnregistered}
                ref={buyerSpec}
                data-buyer-spec-id={
                  props?.contact?.contact?.buyerSpecId
                }
                aria-label="Buyer spec"
              >
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            )}
          <button
            type="button"
            className="nav-icon-button client-detail-action"
            onClick={handleBuyerProperties}
            ref={buyerSpecProperty}
            data-buyer-spec-id={props?.contact?.contact?.buyerSpecId}
            data-buyer-name={getAddressFullName(props?.contact?.contact?.address)}
            data-buyer-ref={props?.contact?.contact?.buyerRef}
            data-buyer-email={props?.contact?.contact?.address?.addressEmails[0]?.emailAddress}
            aria-label="Buyer properties"
          >
            <i className="fa fa-home" aria-hidden="true"></i>
          </button>
        </div>
      ) : null}
    </div>
  );
};
